/*
 * @Description:
 * @Author: rongcheng
 * @@后台人员: xxx
 * @Date: 2022-04-25 13:16:19
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-09-24 09:43:24
 */
import { enumToOption } from '@/utils'
enum plateState {
  SaaS管理平台 = 1,
  SaaS运营平台,
  企业版小程序
}
export const typesOption = enumToOption(plateState)
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 的高度
    height: null,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 100,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'applicationType',
      label: '平台代号',
      width: '140',
      formatter: (row, col, val) => val ? plateState[val] : '-'
    },
    {
      key: 'apiAddress',
      label: '接口地址',
      width: '140'
    },
    {
      key: 'enabled',
      label: '是否开启',
      width: '140',
      formatter: (row, col, val) => val === 1 ? '是' : '否'
    },
    {
      key: 'description',
      label: '描述',
      width: '140'
    },
    // {
    //   key: 'delFlag',
    //   label: '是否删除',
    //   width: '140'
    // },
    {
      key: 'action',
      label: '操作',
      width: '140',
      fixed: 'right',
      slot: 'action'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 搜索变量
  const inputList = [
    {
      type: 'input',
      label: '接口地址',
      key: 'apiAddress',
      placeholder: '请输入',
      labelWidth: 100,
      inputWidth: 200,
      maxlength: 30,
      rules: {}
    },
    {
      type: 'select',
      label: '平台代号',
      key: 'applicationType',
      placeholder: '请选择',
      labelWidth: 100,
      inputWidth: 200,
      options: typesOption,
      rules: {
        type: 'number'
      }
    }
  ]

  // 页面基础变量
  const page = {
    queryForm: {}, // 搜索参数
    total: 0,
    visible: false, // 弹框显示
    title: '新建白名单',
    rowData: null // 单行数据
  }

  return {
    inputList,
    ...page
  }
}
